
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { UserProfile } from '../models/user-profile.model';

@Injectable()
export class PlatformService {
	userProfile = new ReplaySubject<UserProfile>(1);
	userProfile$ = this.userProfile.asObservable();

	announceUserProfile(value: UserProfile): void {
		this.userProfile.next(value);
	}

}
